import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Get token from localStorage
const getToken = () => localStorage.getItem('admin_token');

// Axios instance with auth
const apiClient = axios.create({
  baseURL: API,
});

// Add token to requests
apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth APIs
export const authAPI = {
  login: async (email, password) => {
    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', password);
    
    const response = await axios.post(`${API}/auth/login`, formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
    return response.data;
  },
  
  getMe: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  }
};

// Categories APIs
export const categoriesAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/categories`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await apiClient.post('/categories', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await apiClient.put(`/categories/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await apiClient.delete(`/categories/${id}`);
    return response.data;
  }
};

// Products APIs
export const productsAPI = {
  getAll: async (params = {}) => {
    const response = await axios.get(`${API}/products`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/products/${id}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await apiClient.post('/products', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await apiClient.put(`/products/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await apiClient.delete(`/products/${id}`);
    return response.data;
  }
};

// Orders APIs
export const ordersAPI = {
  getAll: async (status = null) => {
    const params = status ? { status } : {};
    const response = await apiClient.get('/admin/orders', { params });
    return response.data;
  },
  
  updateStatus: async (id, status) => {
    const response = await apiClient.put(`/admin/orders/${id}/status`, { status });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await apiClient.delete(`/admin/orders/${id}`);
    return response.data;
  }
};

// Admins APIs
export const adminsAPI = {
  getAll: async () => {
    const response = await apiClient.get('/admins');
    return response.data;
  },
  
  create: async (data) => {
    const response = await apiClient.post('/admins', data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await apiClient.delete(`/admins/${id}`);
    return response.data;
  }
};

// Stats APIs
export const statsAPI = {
  getDashboard: async () => {
    const response = await apiClient.get('/admin/stats');
    return response.data;
  }
};

export default apiClient;
